export enum MealMode {
    BREAKFAST = 'BS',
    LUNCH = 'BTR',
    AFTERNOON_MEAL = 'BC',
    DINNER = 'BT',
    EXTRA_MEAL = 'BP'
}

export enum NutritionGroupMode {
    PROTEIN = 'P',
    CARBOHYDRATE = 'C',
    VEGETABLE = 'V',
    FRUIT = 'F',
    MILK = 'M',
    OIL = 'O'
}

export enum FOOD_TYPE {
    NHOM_CHAT_DAM = 'THUCPHAMGIAUCHATDAM',
    NHOM_CHAT_BOT_DUONG = 'THUCPHAMGIAUCHATBOTDUONG',
    RAU_CU_QUA = 'RAUCUQUA',
    TRAI_CAY = 'TRAICAY',
    SUA = 'SUAVACACSANPHAMTUSUA',
    NHOM_GIAU_CHAT_BEO = 'HATDAUMOBO'
}